import clsx from 'clsx';
import { useEffect, useRef } from 'react';

interface ProductVideoProps {
  src: string;
  active: boolean;
}

const ProductVideo: React.FC<ProductVideoProps> = ({ active, src }) => {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;
    if (active) {
      video.currentTime = 0;
      video.play();
    } else {
      video.pause();
    }
  }, [src, active]);

  return (
    <video
      className={clsx({ '--active': active })}
      src={src}
      ref={ref}
      muted
      loop
      autoPlay
      playsInline
    ></video>
  );
};

export default ProductVideo;
